interface IENV {
  appCode: string
  /** labor-service gateway — every /worker and /wrk-* endpoint. */
  apiEndpoint: string
  /**
   * hrm-service gateway — the masters workers share with employees (read-only here), and the
   * /file/show route that serves uploaded worker photos and documents. See config/api.config.ts.
   */
  hrmApiEndpoint: string
  envType?: string
  ssoGetway: string
  ssoURL?: string
  /**
   * Origin of `ssoURL` — the SSO portal host, for cross-app links such as the profile menu.
   * Derived once here rather than at each call site, which is how two of those links ended up
   * hardcoded to sso.erpboi.com. Falls back to this install's own console when ssoURL is
   * unset or malformed — never the other brand's host, where nobody here has a session.
   */
  ssoOrigin: string
  /** Product name shown in the UI and appended to the browser tab title. */
  brandName: string
  /** This console's name, e.g. "Labor Welfare" — part of the browser tab title. */
  appName: string
  /** Public path to this deployment's logo — the fallback when a company has no uploaded logo. */
  brandLogo: string
  /** Public path to this deployment's favicon. */
  brandFavicon: string
  /** Support address shown on the Help page. */
  supportEmail: string
}

/**
 * This install's own console origin — the fallback when the env var is unset or malformed.
 * No trailing slash: it is concatenated with paths (`${origin}/dashboard`, `/profile`), and
 * `new URL(...).origin` has none either, so the fallback matches the shape of the real value.
 */
const CONSOLE_ORIGIN = 'https://login-phoenixerp.skydigitalbd.com'

const originOf = (url?: string): string => {
  try {
    return new URL(url || '').origin
  } catch {
    return CONSOLE_ORIGIN
  }
}

export const ENV: IENV = {
  appCode: process.env.REACT_APP_CODE || '',
  envType: process.env.REACT_APP_ENV_TYPE || '',
  apiEndpoint: process.env.REACT_APP_GETWAY || '',
  hrmApiEndpoint: process.env.REACT_APP_HRM_GETWAY || '',
  ssoURL: process.env.REACT_APP_SSO_URL || '',
  ssoGetway: process.env.REACT_APP_SSO_GETWAY || '',
  ssoOrigin: originOf(process.env.REACT_APP_SSO_URL),
  brandName: process.env.REACT_APP_BRAND_NAME || 'ErpBoi',
  appName: process.env.REACT_APP_APP_NAME || 'Labor Welfare',
  brandLogo: process.env.REACT_APP_BRAND_LOGO || '/media/logos/logo.png',
  brandFavicon: process.env.REACT_APP_BRAND_FAVICON || '/media/logos/favicon.ico',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@erpboi.com',
}
